export default __webpack_public_path__ + "static/media/BlueCircle.332c1b36.svg";